// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"service-bins_routeHeader_2w2oG","addButton":"service-bins_addButton_2ThyS"};